import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/shortcuts.pdf'; /*Change pdf*/
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {       /*Change left hand panel content*/
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>S&#228;mtliche schriften und briefe series VI volume 3</var><br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		pp 426-427<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: summer 1674 - autumn 1676 (?)<br /><br />
        Translated from the Latin<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (72k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Theorems are Shortcuts for Thinking</title> {/*Change title*/}
            <meta name="description" content="An English translation of THEOREMS ARE SHORTCUTS FOR THINKING by Gottfried Wilhelm Leibniz, from summer 1674 - autumn 1676 (?)" /> {/*Change meta description*/}
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: THEOREMS ARE SHORTCUTS FOR THINKING</h2> {/*Change title*/}
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br /> {/*Change page content*/}
                 [<b>A VI 3, 426</b>]<br /><br />
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;All theorems are nothing but shorthand, or shortcuts for thinking, which spare the mind from having to think distinctly about things themselves, without thereby preventing everything from turning out correctly. In this lies the entire usefulness of words and characters, such as decimal notation in arithmetic and the symbols of analysis, which spare us from having to trace the countless paths of lines and motions, often impossible to express or extraordinarily intricate. [<b>A VI 3, 427</b>] This is what the founders of algebra demonstrated in practice, even if they did not express it in words or through deliberate reflection; and the same is true of the inventors of the algorithm and of those who devised words for use in the sciences. Thus the entire merit of the abstract sciences lies in concise symbols for speaking and writing. It is through these symbols that we can calculate a term of a progression and its sum all at once, without going through each individual term; that we can present something finite as equal to the infinite itself; and that we can accomplish other things of this kind which seem astonishing to those who do not understand the reasons for things.
                <br /><br /><br />
                  &#169; Lloyd Strickland 2026
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
